import { render } from "./EditContrat.vue?vue&type=template&id=e31265ee&ts=true"
import script from "./EditContrat.vue?vue&type=script&lang=ts"
export * from "./EditContrat.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__